export default __webpack_public_path__ + "static/media/tic-tac-toe-1.f8c3830f.webp";